import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers } from '../slices/userSlice';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { UserPlus, Settings } from 'react-feather';
import Users from './Users';
import NewUser from '../components/users/NewUser';
// import Loading from '../components/Loading';

export default function Settigns() {
	const dispatch = useDispatch();
	const [newUserForm, setNewUserForm] = useState(false);
	const token = useSelector((state) => state.auth.token);
	const users = useSelector((state) => state.auth.users) || [];

	const totalUsers = users.length;
	const activeUsers = users.filter((user) => user?.isActive).length;
	const inactiveUsers = totalUsers - activeUsers;

	// const [isLoading, setIsLoading] = useState(true);

	// useEffect(() => {
	// 	setTimeout(() => {
	// 		setIsLoading(false);
	// 	}, 1700);
	// }, []);

	// useEffect(() => {
	// 	dispatch(fetchUsers());
	// }, [dispatch]);

	// if (isLoading) {
	// 	return <Loading />;
	// }

	const closeDetails = () => {
		setNewUserForm(null);
		if (token) dispatch(fetchUsers({ pageSize: 1000, page: 1, sortOrder: 'ASC' }));
	};

	return (
		<div className="flex flex-col h-screen dashboard-page">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				<Sidebar />
				<Users>
					<div className="max-w-7xl mx-auto space-y-6">
						<section className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
							<div className="flex items-start gap-4">
								<div className="p-3 rounded-xl bg-slate-900 text-white shadow-sm">
									<Settings size={26} />
								</div>
								<div>
									<h1 className="text-2xl font-bold text-slate-900">
										Team & Settings
									</h1>
									<p className="text-sm text-slate-500 mt-1">
										Manage users, roles, and account access.
									</p>
								</div>
							</div>

							<div className="flex items-center gap-3">
								<button
									type="button"
									onClick={() => setNewUserForm(true)}
									className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-white font-semibold shadow-sm hover:bg-blue-700 transition-colors"
								>
									<UserPlus size={18} />
									Create user
								</button>
							</div>
						</section>

						<section className="grid grid-cols-1 gap-4 sm:grid-cols-3">
							<div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
								<p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
									Total Users
								</p>
								<p className="mt-2 text-2xl font-bold text-slate-900">
									{totalUsers}
								</p>
							</div>
							<div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
								<p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
									Active
								</p>
								<p className="mt-2 text-2xl font-bold text-slate-900">
									{activeUsers}
								</p>
							</div>
							<div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
								<p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
									Inactive
								</p>
								<p className="mt-2 text-2xl font-bold text-slate-900">
									{inactiveUsers}
								</p>
							</div>
						</section>
					</div>
				</Users>
				{newUserForm && <NewUser onClose={() => closeDetails()} />}

			</div>
		</div>
	);
}
